const initialState = {
    data: null,
};
export const getMyDocumentRedux = (state = initialState, action) => {
    switch (action.type) {
        case 'GETMYDOCUMENT_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'GETMYDOCUMENT_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default getMyDocumentRedux;